import { useState } from 'react';
import '../Styles/NewSubPage.css';
import logo from "../Images/TalkGovTech Logo.png"

function Subpage() {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        jobFunction: '',
        seniority: '',
        country: '',
        interests: {
            analytics: false,
            artificial_intelligence: false,
            automation: false,
            enterprise_app: false,
            big_data: false,
            digital_transformation: false,
            gen_ai: false,
            strategy: false,
            erp: false
        },
        newsletterOptIn: false,
        resourcesOptIn: false,
        partnerOptIn: false
    });

    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [errors, setErrors] = useState({});

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validateField = (name, value) => {
        let error = '';
        switch (name) {
            case 'firstName':
                if (!value.trim()) error = 'First name is required.';
                else if (!/^[a-zA-Z\s'-]+$/.test(value.trim())) error = 'Letters only.';
                break;
            case 'lastName':
                if (!value.trim()) error = 'Last name is required.';
                else if (!/^[a-zA-Z\s'-]+$/.test(value.trim())) error = 'Letters only.';
                break;
            case 'email':
                if (!value.trim()) error = 'Work email is required.';
                else if (!validateEmail(value)) error = 'Invalid email address.';
                break;
            case 'phone':
                if (!value.trim()) error = 'Phone is required.';
                else if (!/^[+]?[\d\s\-()]{7,20}$/.test(value.trim())) error = 'Invalid phone number.';
                break;
            case 'jobFunction':
                if (!value) error = 'Select a job function.';
                break;
            case 'seniority':
                if (!value) error = 'Select seniority.';
                break;
            case 'country':
                if (!value.trim()) error = 'Country is required.';
                break;

            // NEW VALIDATION: Newsletter Preference
            case 'newsletterOptIn':
                if (value === false) error = 'Please subscribe to the newsletter to proceed.';
                break;
            default:
                break;
        }
        return error;
    };

    const validateAll = () => {
        const newErrors = {};
        ['firstName', 'lastName', 'email', 'phone', 'jobFunction', 'seniority', 'country', 'newsletterOptIn'].forEach(field => {
            const error = validateField(field, formData[field]);
            if (error) newErrors[field] = error;
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;

        if (name.startsWith('interest_')) {
            const interestKey = name.replace('interest_', '');
            setFormData({
                ...formData,
                interests: {
                    ...formData.interests,
                    [interestKey]: checked
                }
            });
        } else {
            const fieldValue = type === 'checkbox' ? checked : value;
            setFormData({
                ...formData,
                [name]: fieldValue
            });

            if (errors[name]) {
                const error = validateField(name, value);
                setErrors(prev => ({ ...prev, [name]: error }));
            }
        }
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;
        if (!name || name.startsWith('interest_') || name.includes('OptIn')) return;
        const error = validateField(name, value);
        setErrors(prev => ({ ...prev, [name]: error }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');

        if (!validateAll()) return;

        setIsLoading(true);

        const interestLabels = {
            analytics: "Analytics",
            artificial_intelligence: "Artificial Intelligence",
            automation: "Automation",
            enterprise_app: "Enterprise Application",
            big_data: "Big Data",
            digital_transformation: "Digital Transformation",
            gen_ai: "Gen AI",
            strategy: "Strategy",
            erp: "ERP"
        };

        // const selectedInterests = Object.keys(formData.interests)
        //     .filter(key => formData.interests[key])
        //     .map(key => interestLabels[key])
        //     .join(', ');

        try {
            const response = await fetch('https://app-node.talkgovtech.com:3022/api/campaign', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    first_name: formData.firstName,
                    last_name: formData.lastName,
                    work_email: formData.email,
                    phone: formData.phone,
                    job_function: formData.jobFunction,
                    job_role: formData.seniority,
                    country: formData.country,
                    // interests: selectedInterests,
                    opt_in1: formData.newsletterOptIn,
                    opt_in2: formData.resourcesOptIn,
                    opt_in3: formData.partnerOptIn
                })
            });

            if (response.ok) {
                setMessage('Subscribed successfully!');
                console.log("response form data :", response);
                setErrors({});
                setFormData({
                    firstName: '',
                    lastName: '',
                    email: '',
                    phone: '',
                    jobFunction: '',
                    seniority: '',
                    country: '',
                    // interests: {
                    //     analytics: false,
                    //     artificial_intelligence: false,
                    //     automation: false,
                    //     enterprise_app: false,
                    //     big_data: false,
                    //     digital_transformation: false,
                    //     gen_ai: false,
                    //     strategy: false,
                    //     erp: false
                    // },
                    newsletterOptIn: false,
                    resourcesOptIn: false,
                    partnerOptIn: false
                });
            } else {
                setMessage('Subscription failed. Please try again.');
            }
        } catch (error) {
            setMessage('An error occurred. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="App newsubpage-root">
            {/* Navbar */}
            <div className="hero-navbar">
                <div className="hero-navbar-inner">
                    <div className="brand">
                        <div className="brand-text">
                            <img style={{ width: "45%" }} src={logo} alt="Talk Gov logo" />
                        </div>
                    </div>
                </div>
            </div>

            {/* Hero Section */}
            <div className="hero-page">
                <div className="hero-overlay"></div>

                <div className="container">
                    <div className="hero-inner">
                        <div className="row align-items-center">
                            {/* Left Column */}
                            <div className="col-xl-6 col-lg-6">
                                <div className="hero-copy">
                                    <h1 className='text-white' style={{ fontWeight: 400, margin: 0, fontFamily: "system-ui, 'Segoe UI', Roboto, sans-serif" }}>
                                       Get the Latest Insights on
                                        <strong>  Government Technology  </strong>
                                    </h1>
                                    <div className="hero-divider"></div>
                                    <div className='hero-paragraph'>
                                        <p className="hero-description">
                                            Talk Govtech is your source for critical insights and best practices from the world of government 
technology. 
                                        </p>
                                        <p className="hero-description">
                                            Whether you're an industry professional, leader, policymaker, or simply curious about the latest 
trends, we have something thought-provoking for you. 
                                        </p>
                                        <p className="hero-description">
                                           Get our latest articles, expert opinions, and insights right in your inbox. 
                                        </p>
                                        <p className="hero-description">
                                            <strong>Sign-up today!</strong>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Right Column - Form Card */}
                            <div className="col-xl-6 col-lg-6">
                                <div className="hero-card">
                                    <div className="hero-card-body">
                                        <form onSubmit={handleSubmit} noValidate>
                                            {/* First Name and Last Name */}
                                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="col-6">
                                                    <div style={{ position: 'relative' }}>
                                                        <label htmlFor="firstName" className={`form-label ${errors.firstName ? 'label-error' : ''}`}>
                                                            First Name<span className="required-asterisk">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="firstName"
                                                            name="firstName"
                                                            value={formData.firstName}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            className="form-input"
                                                            style={errors.firstName ? { borderColor: '#c41b21' } : undefined}
                                                        />
                                                        {errors.firstName && <span className="field-error">{errors.firstName}</span>}
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div style={{ position: 'relative' }}>
                                                        <label htmlFor="lastName" className={`form-label ${errors.lastName ? 'label-error' : ''}`}>
                                                            Last Name<span className="required-asterisk">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="lastName"
                                                            name="lastName"
                                                            value={formData.lastName}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            className="form-input"
                                                            style={errors.lastName ? { borderColor: '#c41b21' } : undefined}
                                                        />
                                                        {errors.lastName && <span className="field-error">{errors.lastName}</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Email */}
                                            <div className="" style={{ position: 'relative' }}>
                                                <label htmlFor="email" className={`form-label ${errors.email ? 'label-error' : ''}`}>
                                                    Work Email<span className="required-asterisk">*</span>
                                                </label>
                                                <input
                                                    type="email"
                                                    id="email"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    className="form-input"
                                                    style={errors.email ? { borderColor: '#c41b21' } : undefined}
                                                />
                                                {errors.email && <span className="field-error">{errors.email}</span>}
                                            </div>

                                            {/* Phone */}
                                            <div className="" style={{ position: 'relative' }}>
                                                <label htmlFor="phone" className={`form-label ${errors.phone ? 'label-error' : ''}`}>
                                                    Phone<span className="required-asterisk">*</span>
                                                </label>
                                                <input
                                                    type="tel"
                                                    id="phone"
                                                    name="phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    className="form-input"
                                                    style={errors.phone ? { borderColor: '#c41b21' } : undefined}
                                                />
                                                {errors.phone && <span className="field-error">{errors.phone}</span>}
                                            </div>

                                            {/* Job Function */}
                                            <div className="mt-1" style={{ position: 'relative' }}>
                                                <label htmlFor="jobFunction" className={`form-label ${errors.jobFunction ? 'label-error' : ''}`}>
                                                    Job Function<span className="required-asterisk">*</span>
                                                </label>
                                                <select
                                                    id="jobFunction"
                                                    name="jobFunction"
                                                    value={formData.jobFunction}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    className="form-input"
                                                    style={{ fontSize: "12px", padding: "4px", ...(errors.jobFunction ? { borderColor: '#c41b21' } : {}) }}
                                                >
                                                    <option value="">Select job function</option>
                                                    <option value="Information Technology">Information Technology</option>
                                                    <option value="IT Security">IT Security</option>
                                                    <option value="Marketing">Marketing</option>
                                                    <option value="Sales">Sales</option>
                                                    <option value="Finance">Finance</option>
                                                    <option value="Human Resources">Human Resources</option>
                                                    <option value="Administration">Administration</option>
                                                    <option value="Operations">Operations</option>
                                                    <option value="Production / Manufacturing">Production / Manufacturing</option>
                                                    <option value="Research & Development">Research & Development</option>
                                                    <option value="Public Relations">Public Relations</option>
                                                </select>
                                                {errors.jobFunction && <span className="field-error">{errors.jobFunction}</span>}
                                            </div>

                                            {/* Seniority */}
                                            <div className="mt-1" style={{ position: 'relative' }}>
                                                <label htmlFor="seniority" className={`form-label ${errors.seniority ? 'label-error' : ''}`}>
                                                    Seniority<span className="required-asterisk">*</span>
                                                </label>
                                                <select
                                                    id="seniority"
                                                    name="seniority"
                                                    value={formData.seniority}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    className="form-input"
                                                    style={{ fontSize: "12px", padding: "4px", ...(errors.seniority ? { borderColor: '#c41b21' } : {}) }}
                                                >
                                                    <option value="">Select seniority</option>
                                                    <option value="Staff">Staff</option>
                                                    <option value="Manager / Sr. Manager">Manager / Sr. Manager</option>
                                                    <option value="Director / Sr. Director">Director / Sr. Director</option>
                                                    <option value="VP / SVP">VP / SVP</option>
                                                    <option value="C-Level">C-Level</option>
                                                </select>
                                                {errors.seniority && <span className="field-error">{errors.seniority}</span>}
                                            </div>

                                            {/* Country */}
                                            <div className="mt-1" style={{ position: 'relative' }}>
                                                <label htmlFor="country" className={`form-label ${errors.country ? 'label-error' : ''}`}>
                                                    Country<span className="required-asterisk">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id="country"
                                                    name="country"
                                                    value={formData.country}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    className="form-input"
                                                    style={errors.country ? { borderColor: '#c41b21' } : undefined}
                                                />
                                                {errors.country && <span className="field-error">{errors.country}</span>}
                                            </div>

                                            {/* Interests */}
                                            {/* <div
                        className="form-check-group"
                        style={{
                          borderTop: '2px solid rgb(221, 221, 221)',
                          paddingTop: '1rem',
                          marginTop: '1rem'
                        }}
                      >
                        <label className="form-label">Interests</label>
                        <div className="interests-grid">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              id="interest_analytics"
                              name="interest_analytics"
                              checked={formData.interests.analytics}
                              onChange={handleChange}
                              className="form-check-input"
                            />
                            <label htmlFor="interest_analytics" className="form-check-label">
                              Analytics
                            </label>
                          </div>

                          <div className="form-check">
                            <input
                              type="checkbox"
                              id="interest_ai"
                              name="interest_artificial_intelligence"
                              checked={formData.interests.artificial_intelligence}
                              onChange={handleChange}
                              className="form-check-input"
                            />
                            <label htmlFor="interest_ai" className="form-check-label">
                              Artificial Intelligence
                            </label>
                          </div>

                          <div className="form-check">
                            <input
                              type="checkbox"
                              id="interest_automation"
                              name="interest_automation"
                              checked={formData.interests.automation}
                              onChange={handleChange}
                              className="form-check-input"
                            />
                            <label htmlFor="interest_automation" className="form-check-label">
                              Automation
                            </label>
                          </div>

                          <div className="form-check">
                            <input
                              type="checkbox"
                              id="interest_bigdata"
                              name="interest_big_data"
                              checked={formData.interests.big_data}
                              onChange={handleChange}
                              className="form-check-input"
                            />
                            <label htmlFor="interest_bigdata" className="form-check-label">
                              Big Data
                            </label>
                          </div>

                          <div className="form-check">
                            <input
                              type="checkbox"
                              id="interest_enterprise"
                              name="interest_enterprise_app"
                              checked={formData.interests.enterprise_app}
                              onChange={handleChange}
                              className="form-check-input"
                            />
                            <label htmlFor="interest_enterprise" className="form-check-label">
                              Enterprise Application
                            </label>
                          </div>

                          <div className="form-check">
                            <input
                              type="checkbox"
                              id="interest_strategy"
                              name="interest_strategy"
                              checked={formData.interests.strategy}
                              onChange={handleChange}
                              className="form-check-input"
                            />
                            <label htmlFor="interest_strategy" className="form-check-label">
                              Strategy
                            </label>
                          </div>

                          <div className="form-check">
                            <input
                              type="checkbox"
                              id="interest_genai"
                              name="interest_gen_ai"
                              checked={formData.interests.gen_ai}
                              onChange={handleChange}
                              className="form-check-input"
                            />
                            <label htmlFor="interest_genai" className="form-check-label">
                              Gen AI
                            </label>
                          </div>

                          <div className="form-check">
                            <input
                              type="checkbox"
                              id="interest_digital"
                              name="interest_digital_transformation"
                              checked={formData.interests.digital_transformation}
                              onChange={handleChange}
                              className="form-check-input"
                            />
                            <label htmlFor="interest_digital" className="form-check-label">
                              Digital Transformation
                            </label>
                          </div>

                          <div className="form-check">
                            <input
                              type="checkbox"
                              id="interest_erp"
                              name="interest_erp"
                              checked={formData.interests.erp}
                              onChange={handleChange}
                              className="form-check-input"
                            />
                            <label htmlFor="interest_erp" className="form-check-label">
                              ERP
                            </label>
                          </div>
                        </div>
                      </div> */}

                                            {/* Email Preferences */}
                                            <div className="form-check-group" style={{ borderTop: '2px solid #ddd', marginTop: '1rem' }}>
                                                <p className="form-label">Email Preferences</p>

                                                <div className="form-check" style={{ position: 'relative' }}>
                                                    <input
                                                        type="checkbox"
                                                        id="newsletter"
                                                        name="newsletterOptIn"
                                                        checked={formData.newsletterOptIn}
                                                        onChange={handleChange}
                                                        className="form-check-input"
                                                        style={errors.newsletterOptIn ? { outline: '1px solid #c41b21', outlineOffset: '2px' } : undefined}
                                                    />
                                                    <label htmlFor="newsletter" className="form-check-label">
                                                        I'd like to receive the Talk Govtech newsletter (circulated 1x per week)
                                                    </label>
                                                    {errors.newsletterOptIn && <span className="field-error checkbox-field-error">{errors.newsletterOptIn}</span>}
                                                </div>

                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        id="resources"
                                                        name="resourcesOptIn"
                                                        checked={formData.resourcesOptIn}
                                                        onChange={handleChange}
                                                        className="form-check-input"
                                                    />
                                                    <label htmlFor="resources" className="form-check-label">
                                                        I'd like to receive Talk govtech resources, reports, and exclusive event invitations
                                                    </label>
                                                </div>

                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        id="partner"
                                                        name="partnerOptIn"
                                                        checked={formData.partnerOptIn}
                                                        onChange={handleChange}
                                                        className="form-check-input"
                                                    />
                                                    <label htmlFor="partner" className="form-check-label">
                                                        I consent to receive messages from Talk govtech and their partners.
                                                    </label>
                                                </div>

                                                <p className="form-note">
                                                    You can unsubscribe at any time by using the link provided in the newsletter and you will be removed from Talk Govtech distribution list.
                                                </p>
                                            </div>

                                            {/* Submit Button */}
                                            <button
                                                type="submit"
                                                disabled={isLoading}
                                                className="btn-danger"
                                            >
                                                {isLoading ? 'SUBSCRIBING...' : 'SUBSCRIBE'}
                                            </button>

                                            {/* Message */}
                                            {message && (
                                                <p className="form-message">
                                                    {message}
                                                </p>
                                            )}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Subpage;